import { For, Show } from "solid-js";
import { api } from "../api/client";
import { t } from "../i18n";
import { createCachedResource } from "../lib/cache";
import { recordsKey } from "../lib/data";
import { formatRecordDate, formatRecordValue, recordKindTitle } from "../lib/records";
import Cell from "./tg/Cell";
import Section from "./tg/Section";

/**
 * Records of one catalog exercise. Loaded when mounted (cached, refreshed after
 * workout writes); nothing is rendered while empty, loading or when the backend
 * has no records endpoint.
 */
export default function ExerciseRecords(props: { exerciseId: string }) {
  const [records] = createCachedResource(() => props.exerciseId || false, {
    key: recordsKey,
    fetch: (id: string) => api.exerciseRecords(id),
  });
  return (
    <Show when={records()?.length}>
      <Section header={t("RECORDS")}>
        <For each={records()}>
          {(r) => (
            <Cell
              title={recordKindTitle(r.kind)}
              subtitle={formatRecordDate(r.date) || undefined}
              value={formatRecordValue(r.kind, r.value)}
            />
          )}
        </For>
      </Section>
    </Show>
  );
}
